import {
  LocalizationMap,
  Viewer,
  Worker,
  SpecialZoomLevel,
  RenderPage,
  RenderPageProps,
  RenderViewer,
  Tooltip,
  MinimalButton,
  Position,
  Icon,
} from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import de_DE from "@react-pdf-viewer/locales/lib/vi_VN.json";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import { ClassAttributes, HTMLAttributes, useEffect, useState } from "react";
import {
  Group,
  Text,
  Code,
  rem,
  Button,
  Select,
  JsonInput,
  Grid,
  Menu,
  Divider,
  ScrollArea,
  Checkbox,
  ComboboxItem,
} from "@mantine/core";
import { randomId, useListState, useMove } from "@mantine/hooks";
import "@mantine/core/styles.css";
import "@mantine/notifications/styles.css";
import "@mantine/dropzone/styles.css";
import "./Main.css";
import disableScrollPlugin from "./slide-presentation/disableScrollPlugin";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/page-navigation/lib/styles/index.css";
import {
  pageNavigationPlugin,
  RenderGoToPageProps,
} from "@react-pdf-viewer/page-navigation";
import { Rnd } from "react-rnd";
import {
  Documents,
  findDocumentBySignatureId,
  listColor,
  SignaturePosition,
} from "./Document";

type State = {
  x: number;
  y: number;
  width: number;
  height: number;
};
interface PageItem {
  label: string;
  value: string;
  checked: boolean;
  key: number;
}
export const style = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  border: "solid 1px #ddd",
  background: "#f0f0f0",
  zIndex: 9999,
};

export const parentBoundary = {
  background: "#eee",
  width: "100%",
  height: "100%",
};

export const selectorBoundary = {
  background: "#d1d8ff",
  padding: "20px",
  width: "100%",
  height: "100%",
};

function MainComponent() {
  const [data, setData] = useState<Array<Documents>>([]);

  const workerUrl = new URL(
    "pdfjs-dist/build/pdf.worker.min.js",
    import.meta.url
  ).toString();
  const defaultLayoutPluginInstance = defaultLayoutPlugin();
  const disableScrollPluginInstance = disableScrollPlugin();
  const pageNavigationPluginInstance = pageNavigationPlugin();
  const { GoToNextPage, GoToPreviousPage } = pageNavigationPluginInstance;
  const [selectedItemId, setSelectedItemId] = useState<string>("");

  //
  const renderPage: RenderPage = (props: RenderPageProps) => {
    return (
      <>
        {props.canvasLayer.children}
        {props.annotationLayer.children}
        {props.textLayer.children}
        {data.map((doc, index) =>
          doc.ky
            .filter(
              (signaturePage) => signaturePage.page === props.pageIndex + 1
            ) // Lọc các chữ ký theo page hiện tại
            .map((signaturePage, pageIndex) =>
              signaturePage.list.map((item, i) => (
                <Rnd
                  key={item.id}
                  bounds={boundaryElm}
                  size={{
                    width: item.with,
                    height: item.height,
                  }}
                  position={{
                    x: item.x,
                    y: item.y,
                  }}
                  onDragStop={(e: any, d: any) => {
                    const updatedKy = doc.ky.map((kyPage, kyIndex) => {
                      //  if (kyPage.page === pageCurrent) {
                      if (true) {
                        return {
                          ...kyPage,
                          list: kyPage.list.map((pos) =>
                            pos.id === item.id
                              ? {
                                  ...pos,
                                  x:
                                    d.x + pos.with > props.width
                                      ? props.width - pos.with
                                      : d.x < 0
                                      ? 0
                                      : d.x,
                                  y:
                                    d.y + pos.height > props.height
                                      ? props.height - pos.height
                                      : d.y < 0
                                      ? 0
                                      : d.y,
                                }
                              : pos
                          ),
                        };
                      }

                      return kyPage; // Trả về kyPage gốc nếu không phải trang hiện tại
                    });

                    setData(
                      data.map((d) =>
                        d.user.userName === doc.user.userName
                          ? { ...d, ky: updatedKy }
                          : d
                      )
                    );
                  }}
                  onResize={(e, direction, ref, delta, position) => {
                    const updatedKy = doc.ky.map((kyPage, kyIndex) =>
                      //   kyPage.page === pageIndex + 1
                      true
                        ? {
                            ...kyPage,
                            list: kyPage.list.map((pos, posIndex) =>
                              pos.id === item.id
                                ? {
                                    ...pos,
                                    with: ref.offsetWidth,
                                    height: ref.offsetHeight,
                                    ...position,
                                  }
                                : pos
                            ),
                          }
                        : kyPage
                    );
                    setData(
                      data.map((d) =>
                        d.user.userName === doc.user.userName
                          ? { ...d, ky: updatedKy }
                          : d
                      )
                    );
                  }}
                  onClick={() => {
                    if (item.id !== selectedItemId) {
                      setSelectedItemId(item.id);
                      var check = findDocumentBySignatureId(
                        data,
                        selectedItemId
                      );
                      if (check && check.ky[0].page !== pageCurrent) {
                        setPageCurrent(check.ky[0].page);
                      }
                    }
                    //I()
                    // setPageCurrent((prevPage) => prevPage + 1); // Tăng pageCurrent thêm 1
                  }}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    border:
                      selectedItemId === item.id
                        ? "solid 5px orange"
                        : "solid 1px #ddd", // Thay đổi màu border nếu item được chọn
                    background: listColor[index],
                    color: "#fff",
                    zIndex: 9999,
                  }}
                >
                  {`User: ${doc.user.userName} - Signature: ${i + 1}`}
                </Rnd>
              ))
            )
        )}
      </>
    );
  };
  const [pageCurrent, setPageCurrent] = useState<number>(1);
  const [pageTotal, setPageTotal] = useState<number>(1);

  const [state, setState] = useState<State>({
    width: 100,
    height: 100,
    x: 0,
    y: 0,
  });
  const [boundaryElm, setBoundaryElm] = useState<HTMLDivElement>();
  //
  const [selectedLibrary, setSelectedLibrary] = useState<string | null>(
    "React"
  ); // Quản lý giá trị Select

  const handleAddStep = (
    userNameSelect: string,
    type: string,
    pageNumber: number,
    x: number = state.x,
    y: number = state.y,
    w: number = state.width,
    h: number = state.height
  ) => {
    if (userNameSelect) {
      const _sign: SignaturePosition = {
        id: randomId(),
        type: type,
        x: x,
        y: y,
        with: w,
        height: h,
      };

      const existingDocumentIndex = data.findIndex(
        (doc) => doc.user.userName === userNameSelect
      );

      if (existingDocumentIndex !== -1) {
        // Nếu đã tồn tại userNameSelect
        const updatedDocuments = data.map((doc, index) => {
          if (index === existingDocumentIndex) {
            const pageIndex = doc.ky.findIndex(
              (page) => page.page === pageNumber
            ); // Kiểm tra page 1 đã tồn tại

            if (pageIndex !== -1) {
              // Nếu page đã tồn tại, thêm vị trí ký mới vào list
              const updatedKy = doc.ky.map((signaturePage, idx) => {
                if (idx === pageIndex) {
                  return {
                    ...signaturePage,
                    list: [...signaturePage.list, _sign],
                  };
                }
                return signaturePage;
              });

              return { ...doc, ky: updatedKy };
            } else {
              // Nếu page chưa tồn tại, thêm SignaturePage mới
              return {
                ...doc,
                ky: [
                  ...doc.ky,
                  {
                    page: pageNumber,
                    list: [_sign],
                  },
                ],
              };
            }
          }
          return doc;
        });

        setData(updatedDocuments);
      } else {
        // Nếu chưa tồn tại selectedLibrary, tạo Document mới
        const newDocument: Documents = {
          title: `${data.length + 1}`,
          user: {
            userName: userNameSelect,
            email: `${userNameSelect.toLowerCase()}`,
          },
          ky: [
            {
              page: pageNumber,
              list: [_sign],
            },
          ],
        };
        setData([...data, newDocument]);
      }
    }
  };

  //

  const [initialValues, setInitialValues] = useState<PageItem[]>([]);
  useEffect(() => {
    // let arry: ComboboxItem[] = [
    //   {
    //     label: "Tất cả",
    //     value: "-1",
    //   },
    // ];
    let init: PageItem[] = [];
    if (pageTotal > 0) {
      for (let index = 0; index < pageTotal; index++) {
        // arry.push({
        //   label: "Trang " + (index + 1).toString(),
        //   value: index.toString(),
        // });
        init.push({
          label: "Trang " + (index + 1).toString(),
          value: index.toString(),
          checked: false,
          key: index,
        });
      }
      setInitialValues(init);
      handlersCheckbox.setState(init);
    }
  }, [pageTotal]);

  const [values, handlersCheckbox] = useListState(initialValues);

  const allChecked = values.every((value) => value.checked);
  const indeterminate = values.some((value) => value.checked) && !allChecked;
  const itemCheckboxs = values.map((valueCheckbox, index) => (
    <Checkbox
      mt="xs"
      ml={33}
      disabled={selectedItemId == null}
      label={valueCheckbox.label}
      key={valueCheckbox.key}
      checked={valueCheckbox.checked}
      onChange={async (event) => {
        var getSign = findDocumentBySignatureId(data, selectedItemId);
        const _page = Number.parseInt(valueCheckbox.value) + 1;
        if (getSign)
          if (event.currentTarget.checked) {
            if (getSign) {
              const _s = getSign.ky[0].list[0];
              handleAddStep(
                getSign.user.userName,
                _s.type,
                _page,
                _s.x,
                _s.y,
                _s.with,
                _s.height
              );
              handlersCheckbox.setItemProp(index, "checked", true);
            }
          } else {
            const filteredData = data.map((document) => ({
              ...document,
              ky: document.ky.map((signaturePage) => ({
                ...signaturePage,
                list: signaturePage.list.filter(
                  (signature) =>
                    document.user.userName !== getSign?.user.userName ||
                    signaturePage.page !== _page
                ),
              })),
            }));
            setData(filteredData);
            handlersCheckbox.setItemProp(index, "checked", false);
          }
        else {
          alert("chữ ký bạn chọn đã bị xóa !");
        }
      }}
    />
  ));

  return (
    <>
      <div
        style={{
          height: "100px",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <Button
          variant="filled"
          onClick={() => {
            if (selectedLibrary)
              handleAddStep(selectedLibrary, "ký số", pageCurrent);
          }}
        >
          Ký số
        </Button>
        <Button
          variant="filled"
          onClick={() => {
            if (selectedLibrary)
              handleAddStep(selectedLibrary, "ký ảnh", pageCurrent);
          }}
        >
          Ký ảnh
        </Button>
        <Group>
          <Menu shadow="md" width={"150px"} closeOnItemClick={false}>
            <Menu.Target>
              <Button
                disabled={!selectedItemId}
                w={"100%"}
                onClick={() => {
                  const document = data.find((doc) =>
                    doc.ky.some((page) =>
                      page.list.some(
                        (position) => position.id === selectedItemId
                      )
                    )
                  );
                  if (document) {
                    const userName = document.user.userName;
                    const pagesForUser = data
                      .filter((doc) => doc.user.userName === userName)
                      .flatMap((doc) => doc.ky)
                      .map((pageNumber) =>
                        document.ky.find(
                          (page) =>
                            page.page === pageNumber.page &&
                            page.list &&
                            page.list.length > 0
                        )
                      );
                    const _page = Array.from(
                      new Set(pagesForUser?.map((x) => x?.page ?? 0))
                    );
                    handlersCheckbox.setState((current) =>
                      current.map((value) => ({
                        ...value,
                        checked: false,
                      }))
                    );
                    _page.forEach((x) => {
                      handlersCheckbox.setItemProp(x - 1, "checked", true);
                    });
                  } else {
                    console.log(
                      "Không tìm thấy SignaturePosition với ID này trong danh sách Documents."
                    );
                  }
                }}
              >
                Chọn trang ký
              </Button>
            </Menu.Target>

            <Menu.Dropdown>
              <Menu.Label>Danh sách trang</Menu.Label>
              <Divider />
              <ScrollArea mt={"xs"} h={250}>
                {itemCheckboxs}
              </ScrollArea>
            </Menu.Dropdown>
          </Menu>
        </Group>

        <Select
          label="Your favorite library"
          placeholder="Pick value"
          data={["React", "Angular", "Vue", "Svelte"]}
          value={selectedLibrary}
          onChange={(value) => setSelectedLibrary(value)}
        />
          <Button
          variant="filled"
          onClick={() => {
            if (selectedLibrary)
              handleAddStep(selectedLibrary, "ký ảnh", pageCurrent);
          }}
        >
          Ký thử ảnh
        </Button>
      </div>
      <Grid>
        <Grid.Col span={8}>
          {" "}
          <div
            className="rpv-core__viewer"
            style={{
              border: "1px solid rgba(0, 0, 0, 0.3)",
              height: "100%",
              position: "relative",
            }}
          >
            <div
              style={{
                left: 0,
                position: "absolute",
                top: "50%",
                transform: "translate(24px, -50%)",
                zIndex: 1,
              }}
            >
              <GoToPreviousPage>
                {(props: RenderGoToPageProps) => (
                  <Tooltip
                    position={Position.BottomCenter}
                    target={
                      <MinimalButton onClick={props.onClick}>
                        <Icon size={16}>
                          <path d="M18.4.5,5.825,11.626a.5.5,0,0,0,0,.748L18.4,23.5" />
                        </Icon>
                      </MinimalButton>
                    }
                    content={() => "Trang sau"}
                    offset={{ left: 0, top: 8 }}
                  />
                )}
              </GoToPreviousPage>
            </div>

            <div
              style={{
                position: "absolute",
                right: 0,
                top: "50%",
                transform: "translate(-24px, -50%)",
                zIndex: 1,
              }}
            >
              <GoToNextPage>
                {(props: RenderGoToPageProps) => (
                  <Tooltip
                    position={Position.BottomCenter}
                    target={
                      <MinimalButton
                        onClick={() => {
                          setPageCurrent((prevPage) => prevPage + 1); // Tăng pageCurrent thêm 1
                          props.onClick();
                        }}
                      >
                        <Icon size={16}>
                          <path d="M5.651,23.5,18.227,12.374a.5.5,0,0,0,0-.748L5.651.5" />
                        </Icon>
                      </MinimalButton>
                    }
                    content={() => "Trang trước"}
                    offset={{ left: 0, top: 8 }}
                  />
                )}
              </GoToNextPage>
            </div>

            <Group justify="center">
              <div className="App" ref={(ref) => setBoundaryElm(ref!)}>
                <Worker workerUrl={workerUrl}>
                  <Viewer
                    localization={de_DE as unknown as LocalizationMap}
                    fileUrl="https://cdn.syncfusion.com/content/pdf/pdf-succinctly.pdf"
                    plugins={[
                      defaultLayoutPluginInstance,
                      disableScrollPluginInstance,
                      pageNavigationPluginInstance,
                    ]}
                    defaultScale={SpecialZoomLevel.PageFit}
                    renderPage={renderPage}
                    onPageChange={(e) => {
                      if (pageTotal !== e.doc.numPages)
                        setPageTotal(e.doc.numPages);
                      if (e.currentPage !== pageCurrent)
                        setPageCurrent(e.currentPage + 1);
                    }}
                  />
                </Worker>
              </div>
            </Group>
          </div>
        </Grid.Col>
        <Grid.Col span={4}>
          {" "}
          <JsonInput
            label="Your package.json"
            placeholder="Textarea will autosize to fit the content"
            validationError="Invalid JSON"
            formatOnBlur
            autosize
            minRows={10}
            value={JSON.stringify(data)}
          />
        </Grid.Col>
      </Grid>
    </>
  );
}

export default MainComponent;

{
  /* <Menu.Dropdown>
<Menu.Label>Danh sách trang</Menu.Label>
<Divider />
<ScrollArea mt={"xs"} h={250}>
  <Checkbox
    checked={allChecked}
    indeterminate={indeterminate}
    label="Tất cả"
    key={"all"}
    onChange={() => {
      const uncheck = values.filter((x) => x.checked === false);
      const check = values.filter((x) => x.checked === true);

      if (!allChecked) {
        var getSign = findDocumentBySignatureId(
          data,
          selectedItemId
        );
        if (getSign === null || getSign === undefined) {
          alert("Không có chữ ký được chọn");
          return;
        }
        const _s = getSign?.ky[0].list[0];
        if (!_s) {
          alert("Không tìm thấy vị trí chữ ký");
          return;
        }
        //

        const document = data.find((doc) =>
          doc.ky.some((page) =>
            page.list.some(
              (position) => position.id === selectedItemId
            )
          )
        );
        if (document) {
          const userName = document.user.userName;
          const pagesForUser = data
            .filter((doc) => doc.user.userName === userName)
            .flatMap((doc) => doc.ky)
            .map((pageNumber) =>
              document.ky.find(
                (page) => page.page === pageNumber.page
              )
            );
          const _page = Array.from(
            new Set(
              pagesForUser?.map((x) => (x?.page ?? 0).toString())
            )
          );
        }

        //
        for (let index = 0; index < uncheck.length; index++) {
          const element = uncheck[index];
          handleAddStep(
            getSign?.user.userName ?? "",
            _s?.type,
            element.key + 1,
            _s?.x,
            _s?.y,
            _s?.with,
            _s?.height
          );
          // handlersCheckbox.setItemProp(element.key, "checked", true);
        }
      } else {
        // Khi tất cả các mục được bỏ chọn (uncheck all)
        const filteredData = data.map((document) => ({
          ...document,
          ky: document.ky.map((signaturePage) => ({
            ...signaturePage,
            list: signaturePage.list.filter(
              (signature) =>
                document.user.userName !== getSign?.user.userName
            ),
          })),
        }));
        console.log("Delete ............");
        setData(filteredData);
      }
      handlersCheckbox.setState((current) =>
        current.map((value) => ({
          ...value,
          checked: !allChecked,
        }))
      );
    }}
  />
  {itemCheckboxs}
</ScrollArea>
</Menu.Dropdown> */
}
